import { EngineTheme } from '@websky/core/src/theme';

import * as Checkout from './components/Checkout/Checkout.css';
import * as ActionButton from './components/ActionButton/ActionButton.css';

const theme: EngineTheme = {
	Input: {
		Input: {
			real_input: Checkout.input,
			input: Checkout.input
		}
	},
	Button: {
		ActionButton: {
			button: ActionButton.button
		},
		WhiteButton: {
			button: ActionButton.white
		}
	}
};

export default theme;
